import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Cookie, X } from "lucide-react";
import { useCookieConsent } from "@/hooks/useCookieConsent";

interface CookieConsentProps {
  forceOpen?: boolean;
  onClose?: () => void;
}

const CookieConsent = ({ forceOpen, onClose }: CookieConsentProps) => {
  const { isVisible, acceptAll, refuseAll } = useCookieConsent();

  const show = forceOpen || isVisible;

  if (!show) return null;

  const handleAccept = () => {
    acceptAll();
    onClose?.();
  };

  const handleRefuse = () => {
    refuseAll();
    onClose?.();
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-in slide-in-from-bottom-4 duration-300">
      <div className="container mx-auto max-w-4xl">
        <div className="bg-card border border-border rounded-xl shadow-lg p-6">
          <div className="flex items-start gap-4">
            <div className="hidden sm:flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary/10">
              <Cookie className="h-5 w-5 text-primary" />
            </div>
            
            <div className="flex-1 space-y-3">
              <div className="flex items-start justify-between gap-4">
                <h3 className="font-playfair text-lg font-semibold text-foreground">
                  Nous respectons votre vie privée
                </h3>
                {forceOpen && (
                  <button 
                    onClick={onClose}
                    className="text-muted-foreground hover:text-foreground transition-colors"
                    aria-label="Fermer"
                  >
                    <X className="h-5 w-5" />
                  </button>
                )}
              </div>
              
              <p className="text-muted-foreground text-sm leading-relaxed">
                Ce site utilise des cookies pour mesurer l'audience et améliorer votre expérience. 
                Les cookies analytiques nous aident à comprendre comment vous utilisez le site.{" "}
                <Link 
                  to="/legal" 
                  className="text-primary hover:underline"
                >
                  En savoir plus
                </Link>
              </p>
              
              <div className="flex flex-col sm:flex-row gap-3 pt-2">
                <Button 
                  onClick={handleAccept}
                  className="w-full sm:w-auto"
                >
                  Accepter
                </Button>
                <Button 
                  variant="outline" 
                  onClick={handleRefuse}
                  className="w-full sm:w-auto"
                >
                  Refuser
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
